import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import PilProjectData from "./pilSection/pilProjectData";
import { pasDetailFormStyle } from "../../../styles/jss/components/PAS/pasDetailFormStyle";
const useStyles = makeStyles((theme) => pasDetailFormStyle(theme));

const ProjectInformationDetailForm = (props) => {
  const { editable, pilDetails, htmlStr } = props;
  return (
    <Fragment>
      <div>
        {pilDetails.general && pilDetails && (
          <PilProjectData
            editable={editable}
            pilDetails={pilDetails}
            tabValue={0}
            htmlStr={htmlStr}
          />
        )}
      </div>
    </Fragment>
  );
};

export default ProjectInformationDetailForm;
